/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationCnesAliases {
  BREADCRUMB_ACCREDITATION = 'breadcrumb-accreditation',
  FETCH_CNES = 'fetch-cnes',
  FIELD_CNES = 'field-cnes',
  FIELD_MESSAGE_CNES = 'field-message-cnes',
  FORM_CNES = 'form-cnes',
  FORM_PANEL = 'form-panel',
  INPUT_CNES = 'input-cnes',
  LAYOUT_ACTION = 'layout-action',
  LAYOUT_GENERAL_INFORMATION = 'layout-general-information',
  LIST_PANEL = 'list-panel',
  PANEL_ACTION = 'panel-action',
  PANEL_PROVIDER_ACCREDITATION_CNES = 'panel-provider-accreditation-cnes',
  PANEL_START = 'panel-start',
  PANEL_TITLE = 'panel-title',
  START_ACTION = 'start-action',
  TEXT_0 = 'text-0',
  TEXT_3 = 'text-3',
}
export { ProviderAccreditationCnesAliases };
